import { render, staticRenderFns } from "./InboundLabel.vue?vue&type=template&id=3a989bfd"
import script from "./InboundLabel.vue?vue&type=script&lang=js"
export * from "./InboundLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports